import type { PaymentFingerprint, PaymentOption } from '@src/domains/payments/types/payment';

export const collectFingerprints = (options: PaymentOption[]): PaymentFingerprint[] => {
  const byType: { [key: string]: PaymentFingerprint } = {};

  for (const opt of options) {
    if (opt.fingerprints) {
      for (const fingerprint of opt.fingerprints) {
        byType[fingerprint.type] = fingerprint;
      }
    }
  }

  return Object.values(byType);
};
